// extracted by mini-css-extract-plugin
export var arrows = "_2g-5";
export var decrementer = "_2g-9";
export var disabled = "_2g-3";
export var error = "_2g-1";
export var hiddenText = "_2g-a";
export var incrementer = "_2g-8";
export var input = "_2g-7";
export var inputWrapper = "_2g-0";
export var leadingIcon = "_2g-b";
export var readonly = "_2g-2";
export var regular = "_2g-6";
export var small = "_2g-4";